export default __webpack_public_path__ + "static/media/python-plain.5c5fa0ed.svg";